/** Money to two decimals with thousands separators, as a ledger prints it; blank for nothing. */
export function amount(value: number | null | undefined, blankZero = false): string {
  if (value === null || value === undefined) return '';
  if (blankZero && value === 0) return '';
  return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// The organisation's date format and time zone (NFR-011, docs §185), set once a session from /api/v1/locale.
let orgDateFormat = 'd MMM yyyy';
let orgTimeZone: string | undefined;

export function setOrgLocale(dateFormat: string, timeZone: string) {
  orgDateFormat = dateFormat || 'd MMM yyyy';
  try {
    new Intl.DateTimeFormat(undefined, { timeZone });
    orgTimeZone = timeZone;
  } catch {
    orgTimeZone = undefined;
  }
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** A date written to a pattern: dd, d, MM, M, MMM, yyyy, yy. Pure. */
export function formatDate(year: number, month: number, date: number, pattern: string): string {
  return pattern.replace(/yyyy|yy|MMM|MM|M|dd|d/g, (t) => {
    switch (t) {
      case 'yyyy': return String(year);
      case 'yy': return String(year).slice(-2);
      case 'MMM': return MONTHS[month - 1];
      case 'MM': return String(month).padStart(2, '0');
      case 'M': return String(month);
      case 'dd': return String(date).padStart(2, '0');
      default: return String(date);
    }
  });
}

/** A date-only string in the organisation's date format. */
export function day(value: string | null | undefined): string {
  if (!value) return '';
  const [y, m, d] = value.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return value;
  return formatDate(y, m, d, orgDateFormat);
}

/** A timestamp with who did it, for status trails, in the organisation's time zone. */
export function stamp(at: string | null | undefined, by: string | null | undefined): string {
  if (!at) return '';
  return `${new Date(at).toLocaleString(undefined, orgTimeZone ? { timeZone: orgTimeZone } : undefined)}${by ? ` by ${by}` : ''}`;
}

/** Today as a date-only string for date inputs. */
export function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
